interface Props {
    glassColor: string,
    sandColor: string,
    width: string,
    height: string
}

export default function HourGlassRoundedTwoTonedTop( {glassColor,sandColor, width, height} : Props) {
    return (
        <svg
            height={height}
            viewBox="0 0 12 20"
            width={width}
            fill={glassColor}
            version="1.1"
            id="svg2"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs
                id="defs2" />
            <path
                d="M 2,0 C 0.9,0 0,0.9 0,2 V 5.17 C 0,5.7 0.21,6.21 0.59,6.59 L 4,10 0.58,13.42 C 0.21,13.8 0,14.31 0,14.84 V 18 c 0,1.1 0.9,2 2,2 h 8 c 1.1,0 2,-0.9 2,-2 V 14.84 C 12,14.31 11.79,13.8 11.42,13.43 L 8,10 11.41,6.6 C 11.79,6.22 12,5.71 12,5.18 V 2 C 12,0.9 11.1,0 10,0 Z m 8,14.5 V 17 c 0,0.55 -0.45,1 -1,1 H 3 C 2.45,18 2,17.55 2,17 v -2.5 l 4,-4 z M 6,9.5 2,5.5 V 3 C 2,2.45 2.45,2 3,2 h 6 c 0.55,0 1,0.45 1,1 v 2.5 z"
                id="path2" />
            <path
                style={{ fill: sandColor, strokeWidth: 0.0211125 }}
                d="M 3.9535404,7.5084003 1.907455,5.4692425 V 4.140645 c 0,-1.1250093 0.00496,-1.3475833 0.032383,-1.4524969 0.092943,-0.355608 0.3616686,-0.6331586 0.7183924,-0.7419828 0.1207638,-0.036841 0.2826393,-0.03871 3.3520526,-0.03871 h 3.225161 l 0.14804,0.046983 c 0.08143,0.025841 0.184776,0.06939 0.229675,0.096776 0.128355,0.078291 0.299537,0.2593995 0.37038,0.3918622 0.129941,0.2429576 0.129571,0.2381238 0.129571,1.6976494 v 1.32868 L 8.066944,7.508482 C 6.941551,8.629973 6.016017,9.547558 6.010201,9.547558 c -0.0059,0 -0.931312,-0.917621 -2.0566606,-2.0391577 z"
                id="path3" />
        </svg>

    )
}
